
const digest = '90911742713bf1c485417b877942fb7d3e2f3f3393aab035177561babddd9010';
const classes = {"wrapper":"_wrapper_65asn_1","controls":"_controls_65asn_8","formWrapper":"_formWrapper_65asn_18"};
const css = `._wrapper_65asn_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 20px;
}
._wrapper_65asn_1 ._controls_65asn_8 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
  padding: 16px 24px;
  border: 1px solid #eaedf3;
  box-shadow: inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  border-top: 0;
}
._wrapper_65asn_1 ._formWrapper_65asn_18 {
  flex: 1;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  